var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7714 11.1047L8.94275 13.9333C8.81905 14.0572 8.67215 14.1554 8.51046 14.2224C8.34877 14.2894 8.17545 14.3239 8.00042 14.3239C7.82539 14.3239 7.65207 14.2894 7.49038 14.2224C7.32869 14.1554 7.18179 14.0572 7.05808 13.9333L4.22875 11.1047C3.4829 10.3588 2.97497 9.40846 2.76921 8.3739C2.56344 7.33935 2.66908 6.26701 3.07275 5.29248C3.47643 4.31796 4.16002 3.48502 5.03707 2.899C5.91413 2.31298 6.94526 2.00019 8.00008 2.00019C9.05491 2.00019 10.086 2.31298 10.9631 2.899C11.8402 3.48502 12.5237 4.31796 12.9274 5.29248C13.3311 6.26701 13.4367 7.33935 13.231 8.3739C13.0252 9.40846 12.5173 10.3588 11.7714 11.1047V11.1047Z",
    stroke: "#F66700",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.33334C10 7.86377 9.78929 8.37248 9.41421 8.74755C9.03914 9.12262 8.53043 9.33334 8 9.33334C7.46957 9.33334 6.96086 9.12262 6.58579 8.74755C6.21071 8.37248 6 7.86377 6 7.33334C6 6.8029 6.21071 6.29419 6.58579 5.91912C6.96086 5.54405 7.46957 5.33334 8 5.33334C8.53043 5.33334 9.03914 5.54405 9.41421 5.91912C9.78929 6.29419 10 6.8029 10 7.33334V7.33334Z",
    stroke: "#F66700",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3d5db15e0d6deff15bf6501dc2ec31d8.svg";
export { ForwardRef as ReactComponent };